import React from 'react'
import { Switch } from '@mui/material'
import { styled } from '@mui/material/styles'
import themeColors from '@layers-frontend/commons/styles/themeColors'

export const StyledSwitchComponent = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-track': {
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  },
  // Mint only when on, like the switches inside the other panels.
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: themeColors.mintColor
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: themeColors.mintColor,
    opacity: 0.5
  }
}))

const SwitchContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
})

const StyledSwitch = props => {
  return (
    <SwitchContainer>
      <p>{props.label}</p>
      <StyledSwitchComponent {...props} />
    </SwitchContainer>
  )
}

export default StyledSwitch
